import { Link as LinkLi } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { useTheme } from '@material-ui/core/styles';
import HistoryIcon from '@material-ui/icons/History';
import SvgIcon from 'globalcomponents/SvgIcon/Base';
import { pageUrls, ROLES } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasEnabledFeature, hasRestrictedRole } from 'globalutils/fmUtils';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { columns } from './config';
import FilterLogsListForm from './FilterForm';
import UdLogTable from './UdLogTable';

const layout = window?.$environment?.CURRENT_LAYOUT;
const CloseButton = lazy(() => import(`globalcomponents/CloseButton/${layout}`));
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
const Export = lazy(() => import(`globalcomponents/UI/Export/${layout}`));
const Checkbox = lazy(() => import(`globalcomponents/UI/Checkbox/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const Search = lazy(() => import(`globalcomponents/UI/SimpleSearch/${layout}`));
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));

const UndefinedDriverLogs = ({
  i18n,
  udLogList,
  udFilterSuccess,
  apiStatus,
  fetchUdLogList,
  udSetSelectedRow,
  fetchUnAssignedEntries,
  unAssignedEntries,
  drivers,
  saveUnAssignedEntries,
  setUdAssignEntryList,
  clearUdAssignEntryListById,
  callback,
  udLogApiId,
  Styled,
  filters,
  showExtraOptions,
  pagination,
  setPagination,
  clearAll,
}) => {
  //form values for the filter form
  const [values, setValues] = useState({
    driver_name: '',
    dateFrom: '',
    dateTo: '',
  });
  const [isToolsClicked, setIsToolsClicked] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedDriverProfile, setSelectedDriverProfile] = useState(false);
  const [selectedDriverTime, setSelectedDriverTime] = useState(true);
  const [saveIconClicked, setSaveIconClicked] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [errorMsg, setError] = useState('');

  useEffect(() => {
    setPagination(true);
    setValues({
      driver_name: '',
      dateFrom: '',
      dateTo: '',
    });
    const elm = document.getElementsByClassName('reset')?.[0];
    if (elm) {
      elm.click();
    }
  }, [selectedDriverProfile]);

  const theme = useTheme();

  const setSelectedIndexfn = (index) => {
    const { SERVICE_PROVIDER, APP_LAYOUT } = window.$environment;

    let rowLen = 39;
    let wl = 74;

    if (SERVICE_PROVIDER === 'spireon') {
      rowLen = 36;
      wl = 104;
    } else if (APP_LAYOUT === 'NewUi') {
      rowLen = 40;
      wl = 82;
    }

    setSelectedIndex(wl + rowLen * index);
  };

  let exportData = useMemo(() => {
    return udLogList?.filteredList?.map((item) => ({
      [i18n.t('common.driver')]: item.driver_name,
      [i18n.t('common.vehicle')]: item.vehicle_name,
      [i18n.t('common.date')]: item.date,
      [i18n.t('common.hoursWorked')]: item.hours,
      [i18n.t('common.distance')]: item.distance,
      [i18n.t('common.cycleRule')]: item.cycleRule,
    }));
  }, [udLogList?.filteredList]);

  const actions = [
    {
      icon: (row, index) => {
        if (window.$environment.CURRENT_LAYOUT === 'SpireonNew') {
          return (
            <>
              {' '}
              <LinkLi component={Link} to={pageUrls.logsHistory.replace(':id', row.idPub)}>
                <HistoryIcon className="historyIcon" />
              </LinkLi>
            </>
          );
        } else
          return (
            <Icon
              src={mediaUrls?.toolsIcon}
              onClick={() => {
                setIsToolsClicked(true);
                udSetSelectedRow({ index, row });
                setSelectedIndexfn(index);
              }}
            />
          );
      },
    },
  ];

  const selectChange = (e) => {
    udFilterSuccess(e);
  };
  const [clearAllClicked, setClearAllClicked] = useState(false);
  const handleClear = () => {
    setClearAllClicked(true);
  };

  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      {layout !== 'OldUi' && <Breadcrumb filters={filters} />}
      <Styled.Header>
        <>
          <FilterLogsListForm
            values={values}
            udLogList={udLogList}
            handleClear={handleClear}
            udFilterSuccess={udFilterSuccess}
            setValues={setValues}
            i18n={i18n}
            setPagination={setPagination}
            Styled={Styled}
            selectedDriverProfile={selectedDriverProfile}
          />
        </>
      </Styled.Header>
      <Styled.Header>
        <div className="udcheckWrapper">
          <Checkbox
            label={i18n.t('logs.unassignedDriveTime')}
            checked={selectedDriverTime}
            onClick={() => {
              if (!selectedDriverTime) {
                fetchUdLogList({
                  apiId: udLogApiId,
                  data: { showUnidentifiedDriver: false },
                });

                setSelectedDriverTime(true);
                setSelectedDriverProfile(false);
              }
            }}
            id="selectedDriverTime"
          />
          <Checkbox
            label={i18n.t('logs.unidentifiedDriverProfile')}
            checked={selectedDriverProfile}
            onClick={() => {
              if (!selectedDriverProfile) {
                fetchUdLogList({
                  apiId: udLogApiId,
                  data: { showUnidentifiedDriver: true },
                });
                setSelectedDriverTime(false);
                setSelectedDriverProfile(true);
              }
            }}
            id="selectedDriverProfile"
          />
        </div>
        <div className="exportWrapper">
          <Export
            src={mediaUrls.new_export_circle}
            displayText={window.$environment.CURRENT_LAYOUT === 'SpireonNew' ? 'EXPORT' : ''}
            data={exportData}
            filename={i18n.t('logs.logs')}
            toolTip={i18n.t('common.export')}
            className="exportContainer"
            buttonName={i18n.t('Export Data')}
          />
        </div>
        <div className="breadcrumbClass">{layout === 'OldUi' && <Breadcrumb filters={filters} />}</div>
      </Styled.Header>
      <Styled.UdlogTable>
        <div className="spireonNewOnly">
          <span>Unidentified Driver Profile Logs</span>
          <Search
            id={'logSearch'}
            default={udLogList.filteredList}
            onChange={(e) => selectChange(e)}
            width="25%"
            fromData
            query={['driver']}
            placeHolder={'Search Unidentified Driver Profile Logs'}
          />
        </div>
        <div className="spireonOldOnly">{i18n.t('logs.spireonTitle')}</div>
        <UdLogTable
          udLogList={udLogList}
          fetchUnAssignedEntries={fetchUnAssignedEntries}
          i18n={i18n}
          clearAllClicked={clearAllClicked}
          setClearAllClicked={setClearAllClicked}
          unAssignedEntries={unAssignedEntries}
          drivers={drivers}
          apiStatus={apiStatus}
          columns={columns}
          setIsToolsClicked={setIsToolsClicked}
          udSetSelectedRow={udSetSelectedRow}
          saveUnAssignedEntries={saveUnAssignedEntries}
          setUdAssignEntryList={setUdAssignEntryList}
          clearUdAssignEntryListById={clearUdAssignEntryListById}
          clearAll={clearAll}
          callback={callback}
          Styled={Styled}
          actions={actions}
          pageinationReset={pagination}
          pagenationClicked={(e) => {
            setPagination(!e);
          }}
          selectedDriverProfile={selectedDriverProfile}
          saveIconClicked={saveIconClicked}
          setSaveIconClicked={setSaveIconClicked}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          errorMsg={errorMsg}
          setError={setError}
        />

        {isToolsClicked && (
          <Styled.ToolsContainer selectedindex={selectedIndex}>
            <CloseButton
              className="ToolsOptionClose"
              icon={mediaUrls.closeIcon}
              onClick={() => {
                setIsToolsClicked(false);
              }}
            />
            <ul>
              {!hasEnabledFeature('udBulkEditEnabled') && window.$environment.CURRENT_LAYOUT !== 'SpireonOld' && (
                <li>
                  <LinkLi
                    component={Link}
                    to={
                      selectedDriverProfile
                        ? pageUrls.editLog1.replace(':id', udLogList.selectedRow.row.idPub)
                        : pageUrls.editLog.replace(':id', udLogList.selectedRow.row.idPub)
                    }
                  >
                    {i18n.t('common.edit')}
                  </LinkLi>
                </li>
              )}
              <li>
                <LinkLi component={Link} to={pageUrls.logsHistory.replace(':id', udLogList.selectedRow.row.idPub)}>
                  {i18n.t('common.history')}
                </LinkLi>
              </li>
              {showExtraOptions && (
                <li>
                  <LinkLi
                    component={Link}
                    to={`${pageUrls.dailyDocuments}?driver=${udLogList.selectedRow.row.driverId}&day=${udLogList.selectedRow.row.date}`}
                  >
                    {i18n.t('logs.viewDocument')}
                  </LinkLi>
                </li>
              )}
            </ul>
          </Styled.ToolsContainer>
        )}
        <Styled.InfoContainer>
          <p className="seperator">
            <Label>{i18n.t('common.totalHoursWorked')}</Label>
            {window.$environment.CURRENT_LAYOUT !== 'NewUi' ? (
              <Input value={udLogList?.totalHours?.toFixed(2)} disabled={true} />
            ) : (
              <Label>{udLogList?.totalHours?.toFixed(2)}</Label>
            )}
          </p>
          <p className="seperator">
            <Label>{i18n.t('common.totalDistance')}</Label>
            {window.$environment.CURRENT_LAYOUT !== 'NewUi' ? (
              <Input value={udLogList.totalDistance} disabled={true} />
            ) : (
              <Label>{udLogList.totalDistance}</Label>
            )}
          </p>
        </Styled.InfoContainer>
      </Styled.UdlogTable>
    </Box>
  );
};

export default UndefinedDriverLogs;

UndefinedDriverLogs.defaultProps = {};

UndefinedDriverLogs.propTypes = {
  i18n: PropTypes.array.isRequired,
  history: PropTypes.object.isRequired,
  udLogList: PropTypes.object.isRequired,
  udFilterSuccess: PropTypes.func.isRequired,
  apiStatus: PropTypes.object.isRequired,
  clearApiStatus: PropTypes.func.isRequired,
  fetchUdLogList: PropTypes.func.isRequired,
  fetchUnAssignedEntries: PropTypes.func.isRequired,
  unAssignedEntries: PropTypes.object.isRequired,
  saveUnAssignedEntries: PropTypes.func.isRequired,
  setUdAssignEntryList: PropTypes.func.isRequired,
  clearUdAssignEntryListById: PropTypes.func.isRequired,
};
